var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.availableWechatId && _vm.consult && _vm.consult.isShowConsultation ? _c('div', {
    staticClass: "content-section buy-consult",
    attrs: {
      "id": "component-buy-consult"
    }
  }, [_c('div', {
    staticClass: "content-section-title"
  }, [_vm._v("购买咨询")]), _c('div', {
    staticClass: "content-section-main"
  }, [_vm.consult && _vm.consult.total > 0 ? [_c('div', {
    staticClass: "buy-consult-question"
  }, [_vm._v(_vm._s(_vm.consult.question))]), _c('div', {
    staticClass: "buy-consult-answer"
  }, [_c('div', {
    staticClass: "buy-consult-answer-detail",
    class: {
      'no-answer': !_vm.consult.answer
    }
  }, [_vm._v("\n          " + _vm._s(_vm.consult.answer ? _vm.consult.answer : '(☉д⊙) 暂无答复...') + "\n        ")]), _vm.consult.answer ? _c('div', {
    staticClass: "buy-consult-answer-detail-time"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.consult.answerTime)))]) : _vm._e()]), _c('div', {
    staticClass: "buy-consult-user"
  }, [_c('div', {
    staticClass: "buy-consult-user-msg"
  }, [_c('ycf-image', {
    attrs: {
      "src": _vm.consult.usePic ? _vm.consult.usePic : _vm.defaultAvatar
    }
  }), _c('span', [_vm._v(_vm._s(_vm.consult.userName))])], 1), _c('div', {
    staticClass: "buy-consult-user-time"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.consult.questionTime)))])]), _c('div', {
    staticClass: "content-section-more buy-consult-more",
    on: {
      "click": function click($event) {
        return _vm.goAdvisory();
      }
    }
  }, [_c('span', [_vm._v("更多咨询（" + _vm._s(_vm.consult.total) + "条）")]), _c('ycf-svg', {
    staticClass: "iconfont arrowleft",
    attrs: {
      "icon-name": "arrowleft"
    }
  })], 1)] : [_c('div', {
    staticClass: "to-advisor-wrap"
  }, [_c('p', [_vm._v("暂无咨询，等您提问")]), _c('div', {
    staticClass: "to-advisor-btn",
    on: {
      "click": function click($event) {
        return _vm.goAdvisory();
      }
    }
  }, [_vm._v("\n          去提问\n          "), _c('ycf-svg', {
    staticClass: "iconfont arrowleft",
    attrs: {
      "icon-name": "arrowleft"
    }
  })], 1)])]], 2)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };